import React from 'react';

import useStyles from './signingInStyles';

const SigningIn: React.FC = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <p role="status" className={classes.message}>
        Signing you in…
      </p>
    </div>
  );
};

export default SigningIn;
